import axios, { AxiosRequestConfig } from 'axios';
import { getAuthToken } from 'utils/cartHelpers';
import { API_ROOT } from 'utils/constants/urls';

// Custom interceptor to add a fresh JWT to each request
const jwtInterceptor = async (
  config: AxiosRequestConfig,
): Promise<AxiosRequestConfig> => {
  const authToken = await getAuthToken();
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`; // eslint-disable-line no-param-reassign
    return config;
  }
  return Promise.reject(new Error('No authorization token found'));
};

// Create our axios instance with API_ROOT set
const StoreApi = axios.create({
  baseURL: API_ROOT,
});

// Add default content type to headers
StoreApi.defaults.headers.common['Content-Type'] = 'application/json';

// Add interceptor to instance
StoreApi.interceptors.request.use(jwtInterceptor, (error) => {
  Promise.reject(error);
});

export default StoreApi;
export { StoreApi, jwtInterceptor };
